<script>
    /*
    	SortField.svelte
    */

    import { onMount } from 'svelte';

    // TCARE components

    const SVG_ASCENDING_PATH = '/img/chevron_up_purple.png';
    const SVG_DESCENDING_PATH = '/img/chevron_down_purple.png';
    
    export let label;
    export let propName;
    export let onSort;              // on ResourceExplorerPage

    $: isAscending = true;

    onMount(() => {
    })

    const _onClick = () => {
        let sortField = "";
        isAscending = !isAscending;
        // must translate these for the Sort API
        if (propName === "service-name") sortField = "name";
        if (propName === "average-rating") sortField = "rating";
        onSort(sortField, isAscending);
    }

</script>

<style>
    .sort-field {
        /* width: 120px; */
        /* margin-right: 20px; */
        padding: 0px 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        /* border: 1px solid blue; */
    }

    .sort-field-button {
        width: 20px;
        height: 20px;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        /* background: none; */
        background: #DFCDD8;
        border-radius: 50%;
    }

    .sort-field-button.selected {
        background: #DFCDD8;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="sort-field" on:click={_onClick}>
    <div class="sort-field-button">
        {#if isAscending}
            <img src={SVG_ASCENDING_PATH} alt={'Chevron up'} draggable="false" >
        {:else}
            <img src={SVG_DESCENDING_PATH} alt={'Chevron down'} draggable="false" >
        {/if}
    </div>
    {label}
</div>
